import reduxConnector from 'root/src/shared/util/reduxConnector'

import recordClickActionLoadingSelector from 'root/src/client/logic/api/selectors/recordClickActionLoadingSelector'
import recordClickActionLabelSelector from 'root/src/client/logic/api/selectors/recordClickActionLabelSelector'

import recordClickAction from 'root/src/client/logic/api/thunks/recordClickAction'

export default reduxConnector(
	[
		['loading', recordClickActionLoadingSelector],
		['label', recordClickActionLabelSelector],
	],
	[
		['recordClickAction', recordClickAction],
	],
)
